import { Sprite } from './types';

export const LARGE_SPRITES: Sprite[] = [
  {
    name: 'Flareon',
    imageUrl: 'https://mahval-large-sprites.s3.eu-west-1.amazonaws.com/136Flareon.png',
  },
  {
    name: 'Jolteon',
    imageUrl: 'https://mahval-large-sprites.s3.eu-west-1.amazonaws.com/135Jolteon.png',
  },
];
